export default __webpack_public_path__ + "static/media/road-hazard.81215b13.svg";